import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { removeTextUnderlineOnHover } from '@/theme';

export const FormWrapper = styled(Flex)`
  flex-direction: column;
  max-width: 500px;
  margin: 0 auto;
  ${({ theme }) => css`
    gap: ${theme.spacing(2)};
  `}
`;

export const Link = styled(LinkWithLocale)`
  ${removeTextUnderlineOnHover};
`;
